import React from "react";
import classes from "../../style/HomeScreen.module.css";
import { useNavigate } from "react-router-dom";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Dexter_Splash2 } from "../../Routes";

const WelcomeScreen = () => {
  const Navigate = useNavigate();

  const HandleSubmit = () => {
    Navigate(Dexter_Splash2);
  };
  return (
    <div className={classes.Main_Container}>
      <header className={classes.Splash1Header}>
        <img alt="" src={NewDexterLogo} className={classes.DexterLogo} />
      </header>
      <div className={classes.Internal_Main_Container}>
        <span className={classes.SplashHeading1}>
          World's first Passive only <span className={classes.WealthWord}>Wealth</span> Tech Platform
        </span>

        <span className={classes.SplashSubHeading}>
          Access High Performing passive portfolios.
        </span>

        <div className={classes.Spash_Button_Container}>
          <button className={classes.SplashButton} onClick={HandleSubmit}>
            Begin  <KeyboardArrowRightIcon className={classes.RightButtonArrow} />
          </button>
        </div>


      </div>
    </div>
  );
};

export default WelcomeScreen;
